module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.22747/images/logos/hubspot-logo-hsfx.svg"